import React, { createContext, useContext } from "react";

export type CompanyState = {
  sidebarTitle: string | null;
  setSidebarTitle: (t: string | null) => void;
};

const CompanyCtx = createContext<CompanyState | null>(null);

export function CompanyProvider({ value, children }: { value: CompanyState; children: React.ReactNode }) {
  return <CompanyCtx.Provider value={value}>{children}</CompanyCtx.Provider>;
}

export function useCompany() {
  const ctx = useContext(CompanyCtx);
  if (!ctx) throw new Error("useCompany must be used within CompanyProvider");
  return ctx;
}

